import { ShieldOff } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import AppButton from "../ui/AppButton";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-6 text-center">
      <ShieldOff className="h-12 w-12 text-pColor" />
      <h1 className="text-xl font-semibold text-hColor">
        You don't have access to this page
      </h1>
      <p className="max-w-md text-sm text-pColor">
        Your role doesn't include the permission required to view this page.
        Contact your administrator if you think this is a mistake.
      </p>
      <AppButton onClick={() => navigate(-1)} className="w-auto px-6">
        Go back
      </AppButton>
    </div>
  );
};

export default Unauthorized;
